<template>
  <div>
    <div class="mobile-target">
      <div v-if="isMobile">
        <component v-touch:swipe="swipeHandler"
                   ref="comp" @hook:mounted="initSections()" v-bind:is="component" @completed="confirm" @returnToOption="returnToOption" />
      </div>
      <div v-else>
        <component ref="comp" v-bind:is="component" @completed="confirm" @returnToOption="returnToOption" />
      </div>
    </div>
    <NextButton v-if="showNavigateNext" @clicked="navigateNext" />
  </div>
</template>

<script>
import '@/styles/application.scss';
import NextButton from '@/components/NextButton.vue';
import PaymentOptions from '@/payments/PaymentOptions.vue';
import DirectDebit from '@/payments/DirectDebit.vue';
import CardPayment from '@/payments/CardPayment.vue';
import { mapState, mapGetters } from 'vuex';
import Mobile from '../mobile/mobile';
import ga from '../ga';

export default {
  name: 'Payments',
  props: {
    backButton: HTMLAnchorElement,
    cancelBack: Boolean,
  },
  mounted() {
    try {
      ga.sendCardPayment(this.application.Type);
    } catch (e) {
      console.log(e);
    }
  },
  data() {
    return {
      comps: [
        PaymentOptions,
        DirectDebit,
        CardPayment,
      ],
      component: PaymentOptions,
    };
  },
  watch: {
    cancelBack(update) {
      if (update) {
        this.loadPayments();
      }
    },
  },
  components: {
    CardPayment,
    PaymentOptions,
    NextButton,
    DirectDebit,
  },
  methods: {
    swipeHandler(direction) {
      Mobile.swipeHandler(direction, this.$refs.comp);
    },
    navigateNext() {
      if (this.isFinalSection) {
        this.$refs.comp.confirm();
      } else Mobile.swipeHandler('left', this.$refs.comp);
    },
    initSections() {
      Mobile.initSections(this.$refs.comp.$el);
    },
    loadComponentOnConfirm(comp, option) {
      return {
        paymentCompleted: comp === DirectDebit || comp === CardPayment,
        paymentType: option.PaymentMethod !== 'Card' ? 'DirectDebit'
          : 'Braintree',
      };
    },
    confirm() {
      const loaderOptions = this.loadComponentOnConfirm(
        this.component,
        this.paymentOption,
      );
      const loadDirectDebit = () => {
        this.$refs.comp.$destroy();
        this.component = this.comps.find((comp) => comp === DirectDebit);
        if (this.isMobile) window.scroll(0, 20);
      };
      const loadBraintree = () => {
        this.$refs.comp.$destroy();
        this.component = this.comps.find((comp) => comp === CardPayment);
        if (this.isMobile) window.scroll(0, 20);
      };
      const completed = () => {
        this.$emit('completed');
      };

      if (loaderOptions.paymentCompleted) {
        completed();
      } else if (loaderOptions.paymentType === 'DirectDebit') {
        loadDirectDebit();
      } else if (loaderOptions.paymentType === 'Braintree') {
        loadBraintree();
      } else {
        throw new Error('No loader option found');
      }
    },
    returnToOption() {
      this.$refs.comp.$destroy();
      this.component = PaymentOptions;
      if (this.isMobile) window.scrollTo(0, 20);
    },
    loadPayments() {
      this.component = PaymentOptions;
      window.scroll(0, 20);
      this.$emit('resetCancelBack', false);
    },
  },
  computed: {
    ...mapState(['isMobile', 'paymentOption', 'application']),
    ...mapGetters(['isFinalSection']),
    showNavigateNext() {
      return this.component.name === 'DirectDebit' && !this.isFinalSection;
    },
  },
};
</script>
<style>
</style>
